<template>
	<div class="autocomplete">
	    <input type="text" @blur="onChange" v-model="search"  @click="showAll" />
	    <ul id="autocomplete-results" v-show="isOpen" ref="scrollContainer" class="autocomplete-results">
	      	<li class="loading" v-if="isLoading">
	        	Loading results...
	      	</li>
	      	<li ref="options" v-else v-for="(result, i) in filterResults" :key="i" @click="setResult(result, i)" class="autocomplete-result" :class="{ 'is-active': i === arrowCounter }">
	        	{{ result.name }}
	      	</li>
	    </ul>
	    <b class="error-text" v-if="text == '' && isOpen">Thông số sẽ không được lưu nếu như bạn chưa chọn</b>
	</div>
</template>
<script>
export default {
    props: {
	    items: {
	      	type: Array,
	      	required: false,
	      	default: []
	    },
	    isAsync: {
	      	type: Boolean,
	      	required: false,
	      	default: false
	    },
	    param : {
	    	type : Number,
	      	required: false,
	    	default: 0
	    }
	},

	data() {
	    return {
	      	isOpen: false,
	      	results: [],
	      	search: "",
	      	isLoading: false,
	      	arrowCounter: 0,
	      	id: 0,
	      	text : '',
	    };
	},

	methods: {
	    onChange() {
	      	// Let's warn the parent that a change was made
	      	this.$emit("input", this.search);
	    },
	    setResult(result, i) {
	      	this.arrowCounter = i;
	      	this.search = result.name;
	      	this.text = result.name;
	      	this.id = result.id;
	      	this.isOpen = false;
	    },
	    showAll() {
	      	this.isOpen = !this.isOpen;
				(this.isOpen) ? this.results = this.items : this.results = [];
	    },
	},
	created(){
		this.id = this.param
	},
	computed: {
	    filterResults() {
	      // first uncapitalize all the things
	    	this.results = this.items.filter(item => {
	        	return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
	      	});
	      
	     
	      return this.results;
	    },
	},
	watch: {
	    items: function(val, oldValue) {
	      	// actually compare them
	      	if (val.length !== oldValue.length) {
	        	this.results = val;
	        	this.isLoading = false;
	      	}
	    },
	    id(val){
	    	this.items.map(item => {
	    		if(item.id == val){
	    			this.search = item.name;
	    		}
	    	})
	    	this.$emit("update:param", val);
	    }
	},
	mounted() {
	    document.addEventListener("click", this.handleClickOutside);
	},
	destroyed() {
	    document.removeEventListener("click", this.handleClickOutside);
	}
}
</script>
<style lang="scss">

.autocomplete {
	position: relative;
	width: 100%;
	input{
	    background-color: #fff;
	    background-image: none;
	    border-radius: 4px;
	    border: 1px solid #dcdfe6;
	    box-sizing: border-box;
	    color: #606266;
	    display: inline-block;
	    height: 40px;
	    line-height: 40px;
	    outline: none;
	    padding: 0 25px 0 15px;
	    width: 100%;
	    cursor: pointer;

	}
	.error-text{
		color : #ef3b4c;
		font-size: 11px;
	}
}

.autocomplete-results {
	padding: 0;
	margin: 0;
	border: 1px solid #eeeeee;
	height: 120px;
	overflow: auto;
	width: 100%;
}

.autocomplete-result {
	list-style: none;
	text-align: left;
	padding: 4px 2px;
	cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
	background-color: #4aae9b;
	color: white;
}
    
</style>